import React from "react";
import GalleryItem from "./gallery-item";

const Gallery = ({gallery}) => {
    switch (gallery.style) {
        default: // grid
            return (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-14">
                    {gallery.images.map((image) => (
                        <GalleryItem key={image.id} image={image} />
                    ))}
                </div>
            )
    }
}

export default Gallery